import { deliveryType } from 'pando-constants';

export const isPTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === 'PTL';

/**
 *
 * @param {*} indentDeliveryType
 * Input string as FTL
 */
export const isFTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === 'FTL';

export const isPerCFT = type =>
  type && type === 4;

export const isPerTon = type =>
  type && type === 2;
